import { z } from 'zod';

const email = z.email('This address has no domain');

// These rules mirror `RegisterReqDto`; a looser or stricter one misreports the server.
const password = z
  .string()
  .min(8, 'At least 8 characters')
  .max(128, 'No more than 128 characters')
  .regex(/[A-Za-z]/, 'Needs at least one letter')
  .regex(/[0-9]/, 'Needs at least one number');

const name = z.string().min(1, 'Tell us what to call you');

export const signInSchema = z.object({
  email,
  password: z.string().min(1, 'Enter your password'),
});

export const registerSchema = z.object({
  organizationName: z.string().min(1, 'Name the organization'),
  name,
  email,
  password,
});

export const forgotPasswordSchema = z.object({ email });

export const newPasswordSchema = z.object({ password });

export const acceptInvitationSchema = z.object({ name, password });

export type TSignIn = z.infer<typeof signInSchema>;
export type TRegister = z.infer<typeof registerSchema>;
export type TForgotPassword = z.infer<typeof forgotPasswordSchema>;
export type TNewPassword = z.infer<typeof newPasswordSchema>;
export type TAcceptInvitation = z.infer<typeof acceptInvitationSchema>;
